module.exports = __webpack_public_path__ + "img/Picture2.61f0eba0.png";